import HexController from 'controllers/hex_controller';

export default class extends HexController {
  _locking = false;
  _mutationObserver = null;

  connect() {
    window.navigationLockController = this;
  }

  disconnect() {
    this.unlock();
    window.navigationLockController = null;
  }

  mutationObserver() {
    if (this._mutationObserver) {
      return this._mutationObserver;
    }
    this._mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE && node.matches('.prevent-navigation')) {
              node.addEventListener('click', event => {
                this.navCheck(event);
              });
            }
          });
        }
      });
    });
    return this._mutationObserver;
  }

  navCheck(event) {
    if (this._locking) {
      event.preventDefault();
      event.stopPropagation();
      const toUrl = event.detail.url || event.target.closest('a')?.href || '/';
      this.showWarningDialog(toUrl);
    }
  }

  lock() {
    this._locking = true;
    this.setOnBeforeUnload();
    document.querySelectorAll('a[data-turbo="false"], .prevent-navigation').forEach((element) => {
      element.addEventListener('click', event => {
        this.navCheck(event);
      });
    });
    document.addEventListener("turbo:before-visit", event => {
      this.navCheck(event);
    });
    this.mutationObserver().observe(document.body, {
      childList: true,  // Watch for changes in direct children
      subtree: true     // Watch for changes in all descendants
    });
  }

  unlock() {
    if (this._locking) {
      this._locking = false;
      this.unsetOnBeforeUnload();
      document.querySelectorAll('a, .prevent-navigation').forEach(function(element) {
        element.removeEventListener('click', event => this.navCheck(event));
      });
      document.removeEventListener("turbo:before-visit", event => this.navCheck(event));
      this.mutationObserver().disconnect();
      this._mutationObserver = null;
    }
  }

  setOnBeforeUnload() {
    window.onbeforeunload = function() {
      return '';
    }
  }

  unsetOnBeforeUnload() {
    window.onbeforeunload = null;
  }

  showWarningDialog(toUrl, onclickFunction = '') {
    let onclick;
    if (toUrl) {
      onclick = `window.location.href='${toUrl}'`;
    } else {
      onclick = `${onclickFunction}`;
    }
    const title = this.t('Lose Unsaved Changes Warning');
    const footer = `<button class='btn' onclick="Modalbox.hide()">${this.t('Stay Here')}</button>` +
                   `<button class='btn btn-danger' onclick="Modalbox.hide();window.navigationLockController.unlock();${onclick}">${this.t('Yes, lose changes')}</button>`;
    const options = {
      title: title,
      width: 700,
      center: true,
      transitions: false,
      defaultFooter: true,
      footer: footer,
      // containerClass: 'no-container-padding'
    };
    const body = `<div>${this.t('Leaving this page will cause your unsaved changes to be lost. Are you sure you want to continue?')}</div>` +
                 `<div><strong>${this.t('Choosing "Yes" will cause all unsaved changes to be lost!')}</strong></div>`;
    Modalbox.show(body, options, footer);
  }
}
